import React from "react";
import "./style.css";
import { Col, Row, Container } from "react-bootstrap";

const About = (props) => {
  const { text } = props;
  return (
    <>
      <h2 className="heading">About me</h2>
      <Container>
        <Row>
          <Col>
            <div className="text">{text}</div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
